<template>
  <div>
    <div class="footer">
      <div v-if="location==='right'"></div>
      <div v-if="showName" class="footer-right" @click="onSeeMoreClick">
        {{name}}
        <img class="img" src="../../assets/img/arrowRight.svg" alt="">
      </div>
      <div v-if="location==='left'"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      location: 'right',
      name: '查看完整排行'
    };
  },
  props: {
    locationData: {
      type: String
    },
    footerName: {
      type: String
    },
    showName: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onSeeMoreClick() {
      this.$emit('seeMore');
    }
  },
  mounted() {
    this.location = this.locationData;
    this.name = this.footerName;
  }
};
</script>

<style lang="scss" scoped>
  .footer {
    display: flex;
    height: 44px;
    justify-content: space-between;
    padding: 0 24px 24px;
    color: rgba(255, 255, 255, 0.6);
    background-color: #3e3c42;
    font-size: 14px;
    
    .footer-right {
      cursor: pointer;
    }
    .img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }
}
</style>

